function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Filter_sorteer");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M247.3,234.1V13.5a13.5,13.5,0,0,0-27,0V234.1a68.55,68.55,0,0,0,0,134.4v98.2a13.5,13.5,0,0,0,27,0V368.5a68.55,68.55,0,0,0,0-134.4ZM233.8,342.8a41.5,41.5,0,1,1,41.5-41.5A41.53,41.53,0,0,1,233.8,342.8Z",
  fill: "#00a09b"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M82,120.9V13.5a13.5,13.5,0,0,0-27,0V120.9a68.55,68.55,0,0,0,0,134.4V466.7a13.5,13.5,0,1,0,27,0V255.2a68.49,68.49,0,0,0,0-134.3ZM68.5,229.6A41.5,41.5,0,1,1,110,188.1,41.53,41.53,0,0,1,68.5,229.6Z",
  fill: "#00a09b"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M411.6,120.9V13.5a13.5,13.5,0,0,0-27,0V120.9a68.55,68.55,0,0,0,0,134.4V466.8a13.5,13.5,0,1,0,27,0V255.2a68.49,68.49,0,0,0,0-134.3ZM398.1,229.6a41.5,41.5,0,1,1,41.5-41.5A41.53,41.53,0,0,1,398.1,229.6Z",
  fill: "#00a09b"
});

var SvgFilterSorteer = function SvgFilterSorteer(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 466.6,
    height: 480.3,
    viewBox: "0 0 466.6 480.3",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFilterSorteer, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Filter_sorteer.4a35bff1.svg";
export { ForwardRef as ReactComponent };